import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { pushResource } from './push.resource';

export const pushKeyQuery = () =>
  queryOptions({
    queryKey: ['push', 'key'],
    queryFn: pushResource.key,
    select: (data) => data.publicKey,
    staleTime: Infinity,
  });

export const pushStatusQuery = () =>
  queryOptions({
    queryKey: ['push', 'status'],
    queryFn: pushResource.status,
  });

export function usePushKey() {
  return useQuery(pushKeyQuery());
}

export function usePushStatus() {
  return useQuery(pushStatusQuery());
}

function useInvalidateStatus() {
  const client = useQueryClient();
  return () => client.invalidateQueries({ queryKey: ['push', 'status'] });
}

export function useSubscribePush() {
  const invalidate = useInvalidateStatus();
  return useMutation({
    mutationFn: pushResource.subscribe,
    onSuccess: invalidate,
  });
}

export function useUnsubscribePush() {
  const invalidate = useInvalidateStatus();
  return useMutation({
    mutationFn: pushResource.unsubscribe,
    onSuccess: invalidate,
  });
}

export function useTestPush() {
  return useMutation({ mutationFn: pushResource.test });
}
